import { createSlice } from '@reduxjs/toolkit';
import reducers from 'store/slices/models/reducers';

import { getInitialState } from './initialState';

const slice = createSlice({
  name: 'models',
  initialState: getInitialState(),
  reducers
});

export default slice;
